import { createApp } from 'vue'
import App from './App.vue'
import Home from './Home.vue';
import Generator from './Generator.vue';

import { createWebHistory, createRouter } from 'vue-router'

import '@fontsource-variable/bricolage-grotesque'
import '@fontsource-variable/manrope'
import './assets/base.css'

const routes = [
    { path: '/', component: Home },
    { path: '/generator', component: Generator },
  ]

  const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
      return { top: 0 }
    },
  })

createApp(App).use(router).mount('#app')
